import {AnimatePresence, motion} from 'framer-motion';
import {Spinner, Center, Integer} from 'platform/foundation';
import styled from 'styled-components';

import {useRef} from 'react';

import {isNotNil} from 'ramda';

import {suffixTestId, TestIdProps, useBoolean} from 'shared/web';

interface EmailWindowProps extends TestIdProps {
  htmlData: string | null;
  isRerendering?: boolean;
}

export function EmailWindow(props: EmailWindowProps) {
  const [isIframeLoaded, loadIframe] = useBoolean(false);
  const ref = useRef<HTMLIFrameElement | null>(null);

  return (
    <EmailPreviewContainer data-testid={props['data-testid']}>
      <AnimatePresence>
        {props.isRerendering && (
          <motion.div
            initial={{opacity: 1}}
            animate={{opacity: 1}}
            exit={{opacity: 0}}
            transition={{duration: 0.3, ease: 'easeInOut'}}
            style={{
              position: 'absolute',
              top: 11,
              left: 11,
              right: 11,
              bottom: 11,
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
              zIndex: 10,
              borderRadius: 20,
            }}
          >
            <Center minHeight="100%">
              <Spinner />
            </Center>
          </motion.div>
        )}
      </AnimatePresence>

      {isNotNil(props.htmlData) && (
        <IFrame
          isIframeLoaded={isIframeLoaded}
          srcDoc={props.htmlData ?? ''}
          onLoad={loadIframe}
          loading="eager"
          height="100%"
          ref={ref}
          width="100%"
          data-testid={suffixTestId('iframe', props)}
        />
      )}
    </EmailPreviewContainer>
  );
}

// eslint-disable-next-line eag/no-css-property
const EmailPreviewContainer = styled.div<{minHeight?: Integer}>`
  width: 100%;
  height: 100%;
  background-color: #ecf0f2;
  border-radius: 10px;
  padding: 10px;
`;

// eslint-disable-next-line eag/no-css-property
const IFrame = styled.iframe<{isIframeLoaded: boolean}>`
  visibility: ${({isIframeLoaded}) => (isIframeLoaded ? 'visible' : 'hidden')};
  overflow: auto;
  background-color: #fff;
  border-radius: 20px;
`;
